import React, { useState } from 'react';

const Contact: React.FC = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Handle form submission here
    console.log('Form submitted:', formData);
    // Reset form
    setFormData({ name: '', email: '', subject: '', message: '' });
  };

  return (
    <div className="page">
      <div className="page-hero">
        <div className="container">
          <h1 className="page-title">Contact Us</h1>
          <p className="page-subtitle">
            Have questions? We'd love to hear from you. Send us a message and we'll respond as soon as possible.
          </p>
        </div>
      </div>
      
      <section className="contact-section">
        <div className="container">
          <div className="contact-content">
            <div className="contact-info">
              <h2>Get in Touch</h2>
              <div className="contact-methods">
                <div className="contact-method">
                  <div className="contact-icon email-icon"></div>
                  <h3>Email</h3>
                  <p>support@traveze.com</p>
                  <p>partnerships@traveze.com</p>
                </div>
                <div className="contact-method">
                  <div className="contact-icon phone-icon"></div>
                  <h3>Phone</h3>
                  <p>+1 (555) 123-4567</p>
                  <p>Available 24/7</p>
                </div>
                <div className="contact-method">
                  <div className="contact-icon location-icon"></div>
                  <h3>Address</h3>
                  <p>123 Travel Street</p>
                  <p>San Francisco, CA 94105</p>
                </div>
                <div className="contact-method">
                  <div className="contact-icon chat-icon"></div>
                  <h3>Live Chat</h3>
                  <p>Available on our website</p>
                  <p>Monday - Friday: 9 AM - 6 PM PST</p>
                </div>
              </div>
            </div>
            
            <div className="contact-form">
              <h2>Send us a Message</h2>
              <form onSubmit={handleSubmit}>
                <div className="form-group">
                  <label htmlFor="name">Your Name</label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="email">Email Address</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="subject">Subject</label>
                  <select
                    id="subject"
                    name="subject"
                    value={formData.subject}
                    onChange={handleChange}
                    required
                  >
                    <option value="">Select a subject</option>
                    <option value="general">General Inquiry</option>
                    <option value="support">Technical Support</option>
                    <option value="booking">Booking Assistance</option>
                    <option value="partnership">Partnership Opportunity</option>
                    <option value="feedback">Feedback</option>
                  </select>
                </div>
                <div className="form-group">
                  <label htmlFor="message">Message</label>
                  <textarea
                    id="message"
                    name="message"
                    rows={6}
                    value={formData.message}
                    onChange={handleChange}
                    required
                  ></textarea>
                </div>
                <button type="submit" className="submit-button">Send Message</button>
              </form>
            </div>
          </div>
        </div>
      </section>
      
      <section className="faq-section">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">Frequently Asked Questions</h2>
            <p className="section-subtitle">
              Quick answers to common questions about TRAVEZE
            </p>
          </div>
          <div className="faq-grid">
            <div className="faq-item">
              <h3>How does TRAVEZE's AI work?</h3>
              <p>Our AI analyzes your preferences, budget, and travel history to create personalized itineraries. It considers factors like weather, local events, and your interests to suggest the best activities and destinations.</p>
            </div>
            <div className="faq-item">
              <h3>Is TRAVEZE free to use?</h3>
              <p>Basic trip planning is free! We offer premium features for more detailed itineraries, real-time updates, and priority support. Check our pricing page for more details.</p>
            </div>
            <div className="faq-item">
              <h3>Can I modify my itinerary?</h3>
              <p>Absolutely! Our platform allows you to easily modify, add, or remove activities from your itinerary. The AI will automatically adjust recommendations based on your changes.</p>
            </div>
            <div className="faq-item">
              <h3>Do you offer travel insurance?</h3>
              <p>While we don't provide insurance directly, we partner with trusted travel insurance providers to offer competitive rates and comprehensive coverage options.</p>
            </div>
            <div className="faq-item">
              <h3>How accurate are the recommendations?</h3>
              <p>Our AI is constantly learning and improving. With a 98% satisfaction rate, most travelers find our recommendations highly accurate and helpful for their trips.</p>
            </div>
            <div className="faq-item">
              <h3>Can I use TRAVEZE for business travel?</h3>
              <p>Yes! We offer business travel solutions with expense tracking, approval workflows, and integration with corporate travel policies.</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact; 